import { PageHeader } from '@/shared/components/PageHeader';
import { Briefcase } from 'lucide-react';
import AssignTasksStep from '../components/AssignTasksStep';

export default function CategoryTasksPage() {
  return (
    <>
      <PageHeader
        title="Category Tasks"
        subtitle="Assign and manage tasks within job categories"
        icon={<Briefcase className="size-7 text-primary" />}
      />
      <AssignTasksStep />
    </>
  );
}
